
import Vue from "vue";
import AppBigDownloadButton from "@/components/common/BigDownloadButton.vue";
import { JobService } from "@/services/job-service";
import { Job } from "@/models/job";
import { AWSFileService } from "@/services/aws-file-service";
import { TranslateResult } from "vue-i18n";
export default Vue.extend({
	data(){
		return {
			state: "creating",
			downloadToken: "",
			downloadFileName: ""
		};
	},
	computed: {
		title():TranslateResult{
			if (this.state == "creating"){
				return this.$ct("creating-backup");
			}
			return this.$ct("backup-created");
		}
	},
	methods: {
		download(){
			AWSFileService.downloadFile(this.downloadToken, this.downloadFileName);
		},
		close(){
			this.$emit("close");
		},
		onJobStopped(job:Job){
			if (job.Error != "") {
				this.close();
				return;
			}
			this.state = "done";
			this.downloadToken = job.StatusMessageData[0];
			this.downloadFileName = job.StatusMessageData[1];
		}
	},
	created(){
		JobService.on("job-stopped/create-backup_0", this.onJobStopped);
	},
	destroyed(){
		JobService.off("job-stopped/create-backup_0", this.onJobStopped);
	},
	components: {
		AppBigDownloadButton
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
